import React from 'react'
import 'react-slideshow-image/dist/styles.css';
import { Fade, Zoom, Slide } from 'react-slideshow-image';
import './imageSlider.css';


const slideData = [
    {
        url: '/images/slide1.png',
        caption: 'Slide 1',
    },
    {
        url: '/images/slide2.png',
        caption: 'Slide 2',
    }
]

const divStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '306px',
    backgroundSize: 'cover',
    width: '1050px',
    marginBottom: '40px',
    marginLeft: '210px',
    
}

const spanStyle = {
    fontSize: '20px',
    background: '#efefef',
    color: "#ffffff",
}

export default function imageSlider() {
  return (
    <div className='slide-container'>
        <h5 className='slide-header'>Popular Dishes</h5>
        <Slide>
           {slideData.map((image, index) => (
            <div key={index}>
                <div style={{...divStyle, backgroundImage: `url(${image.url})`}}>
                    <span style={{spanStyle}}>{image.caption}</span>

                </div>
            </div>
           ))}
        </Slide>
       
    </div>
  )
}
